import CustomPopover from "@com/components/custom-popover/index.vue";
import { ref, computed, defineComponent } from "vue";
import { filterSchemaConfig } from "./filter-model";
export default defineComponent({
    components: {
        CustomPopover: CustomPopover
    },
    props: {
        model: Object,
        label: {
            type: String
        },
        unit: {
            type: String,
            default: "%"
        },
        minField: {
            type: String,
            default: "reject_rate_min"
        },
        maxField: {
            type: String,
            default: "reject_rate_max"
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var valueNum = ref(0);
        var popoverSchema = computed(function() {
            return [
                [
                    filterSchemaConfig[props.minField],
                    {
                        label: "-"
                    },
                    filterSchemaConfig[props.maxField],
                    {
                        label: props.unit
                    }, 
                ], 
            ];
        });
        var popoverConfig = {
            width: "auto"
        };
        var selectedValue = computed(function() {
            var min = props.model && props.model[props.minField];
            var max = props.model && props.model[props.maxField];
            var value = "";
            if (min || max) {
                if (min) {
                    value = "".concat(min).concat(props.unit, "\u2264") + value;
                }
                value += props.label;
                if (max) {
                    value = value + "<".concat(max).concat(props.unit);
                }
                return [
                    {
                        label: value,
                        value: props.label
                    }, 
                ];
            }
            return [];
        });
        var handleChange = function(value) {
            valueNum.value = value.value;
            emit("change", value);
        };
        var clearValue = [
            {
                prop: props.minField,
                value: 0
            },
            {
                prop: props.maxField,
                value: 0
            }, 
        ];
        var deleteTag = function(tag) {
            emit("change", clearValue);
        };
        var handleClearClick = function(event) {
            emit("change", clearValue);
        };
        return {
            popoverSchema: popoverSchema,
            selectedValue: selectedValue,
            popoverConfig: popoverConfig,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
